export const composedReportFiltersForm = {
  formId: '1350',
  code: 'composed-repors-saved-filters-1350',
}
